import productViewInstallmentsHtml from './productviewinstallments.component.html';
import './productviewinstallments.component.scss';

class ProductViewInstallmentsController {
    constructor($scope, $http, $interval, ProductViewService, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$interval = $interval;
        this.ProductViewService = ProductViewService;
        this.ModalService = ModalService;

        this.init = false;

        this.santanderPartnerId = null;
        this.caPosId = '';

        this.leaseLinkButton = null;
        this.leaseLinkReady = false;
    }

    $onInit() {
        this.$scope.$watch(() => this.ProductViewService.product, (newProduct, oldProduct) => {
            if (oldProduct && oldProduct.id === newProduct.id) {
                return;
            }
            this.updateSantanderCalculator();
        }, true);

        this.$scope.$watch(() => this.ProductViewService.variant, (newVariant, oldVariant) => {
            if (oldVariant && oldVariant.id === newVariant.id) {
                return;
            }
            this.updateSantanderCalculator();
            this.updateLeaseLinkCalculator();
        }, true);

        this.$scope.$watch(() => this.ProductViewService.price, (newPrice, oldPrice) => {
            console.log('price changed!');
            this.updateLeaseLinkCalculator();
            const installmentsMenuitem = document.getElementById('installments-menuitem');
            if (!installmentsMenuitem) {
                return;
            }
            if (this.displayInstallments) {
                installmentsMenuitem.classList.remove('d-none');
            } else {
                installmentsMenuitem.classList.add('d-none');
            }
        }, true);

        const checkLeaseLinkButtonInterval = this.$interval(
            () => {
                this.leaseLinkButton = document.querySelector('.btn-leaselink');
                if (this.leaseLinkButton) {
                    this.leaseLinkReady = true;
                    this.$interval.cancel(checkLeaseLinkButtonInterval);
                }
            }, 250, 20);
    }

    updateSantanderCalculator() {

    }

    updateLeaseLinkCalculator() {
        if (typeof (productInfoHelper) === 'undefined') {
            return;
        }

        productInfoHelper.setVariantName(this.ProductViewService.variant && this.ProductViewService.variant.name ? this.ProductViewService.variant.name : '');
        productInfoHelper.setName(this.ProductViewService.product.name);
        productInfoHelper.setPrice(Scripts.numberFormat(this.ProductViewService.price.price_gros, 2, ',', ' ').toString().replace(/\s/g, '').replace(',', '.'));

        // Refresh the LeaseLink button
        document.querySelector('.variants-container').click();
    }

    openLeaseLinkCalculator() {
        const llBtn = document.querySelector('.LLBCn > a');
        if (llBtn) {
            llBtn.click();
        }
    }

    openSantanderCalculator() {
        const santanderCalculatorUrl = 'https://wniosek.eraty.pl/symulator/oblicz/numerSklepu/'
            + this.santanderPartnerId + '/wariantSklepu/1/typProduktu/0/wartoscTowarow/'
            + this.ProductViewService.price.price_gros;

        window.open(santanderCalculatorUrl, 'installment_santander', 'width=620, height=620, directories=no, location=no, menubar=no, resizable=yes, scrollbars=yes, status=no, toolbar=no');
    }

    openCaCalculator() {
        const caCalculatorUrl = 'https://ewniosek.credit-agricole.pl/eWniosek/simulator.jsp?PARAM_TYPE=RAT' +
            '&PARAM_PROFILE=' + this.caPosId +
            '&PARAM_CREDIT_AMOUNT=' + this.ProductViewService.price.price_gros;

        window.open(caCalculatorUrl, 'installment_ca', 'width=620, height=520, directories=no, location=no, menubar=no, resizable=yes, scrollbars=yes, status=no, toolbar=no');
    }

    openPayuCalculator() {
        window.open('payu/' + this.ProductViewService.price.price_gros.toString().replace('.', ','), 'installment_payu', 'width=800, height=620, directories=no, location=no, menubar=no, resizable=yes, scrollbars=yes, status=no, toolbar=no');
    }

    showHowToBuyDescription() {
        const modalRef = this.ModalService.add(
            'Jak kupić na <span class="text-primary">e-raty</span>',
            `<div class="row">
                <div class="col-md-6">
                    <h4>1. Wybierz towar i złóż wniosek</h4>
                    <div class="ps-md-4">
                        <p>Dodaj towary do koszyka i jako formę płatności wybierz: <span class="text-primary">Raty Santander Consumer Bank</span>.</p>
                        <p>W e-Wniosku o kredyt na zakup towarów i usług (e-Wniosek) dostosuj do swoich potrzeb okres kredytowania i wpłatę własną, uzupełnij wymagane przez Bank dane, a następnie złóż e-Wniosek i oczekuj na decyzję kredytową Banku.</p>
                        <p>Jeżeli nie uda Ci się dokończyć wypełniania e-Wniosku, będziesz mógł do niego wrócić korzystając z linku, jaki wyślemy do Ciebie na podany w e-Wniosku adres e-mail.</p>
                    </div>
                    <h4>2. Zapoznaj się i potwierdź warunki Umowy o kredyt</h4>
                    <div class="ps-md-4">
                        <p>W przypadku otrzymania pozytywnej decyzji kredytowej, Bank udostępni Ci dokumentację kredytową w wersji elektronicznej (pliki PDF). Zapoznaj się z nią i zaakceptuj na stronie e-Wniosku.</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <h4>3. Potwierdź swoją tożsamość</h4>
                    <div class="ps-md-4">
                        <p>Bank umożliwia Ci potwierdzenie tożsamości na jeden z wybranych przez Ciebie sposobów:</p>
                        <p>• poprzez przelew 1zł: Wykonaj przelew zwrotny o wartości 1 zł na rachunek i w sposób wskazany przez Bank w e-Wniosku. Jest to najszybszy sposób, który - w zależności od dostępności Twojego banku - może potrwać jedynie kilka minut. Niezbędne szczegóły do wykonania przelewu znajdziesz na stronie e-Wniosku. lub</p> 
                        <p>• w obecności pracownika firmy kurierskiej: Kurier przyjedzie do Ciebie pod wskazany w e-Wniosku adres i zweryfikuje Twoją tożsamość na podstawie dokumentu tożsamości wskazanego w e-Wniosku. Pamiętaj! Kurier jedynie weryfikuje Twoją tożsamość, dlatego nie przekazuj mu żadnych kopii dokumentów.</p>
                    </div>
                    <h4>4. Dostawa towaru</h4>
                    <div class="ps-md-4">
                        <p>Po pozytywnej weryfikacji danych potwierdzających Twoją tożsamość Bank informuje nas o możliwości wydania zamówionego towaru.</p>
                        <p>Gotowe! Realizujemy Twoje zamówienie według wybranego sposobu dostawy.</p>
                    </div>
                </div>
            </div>`,
            null,
            true,
            'frame-size-modal',
            'modal-lg modal-installments'
        );

        modalRef.open();
    }

    get displayInstallments() {
        return this.ProductViewService && this.ProductViewService.price && this.ProductViewService.price.price_gros >= 300;
    }
}

let productViewInstallmentsComponent = {
    bindings: {
        santanderPartnerId: '@',
        caPosId: '@'
    },
    template: productViewInstallmentsHtml,
    controller: ProductViewInstallmentsController
}

export default productViewInstallmentsComponent;
